import { useMutation } from '@tanstack/react-query';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import type { ApiResponse } from '../../Http';
import { buildPostRequest } from '../../Http/requestTemplates';
import useHttp from '../../Http/useHttp';
import { settings } from '../../helpers';
import type { PaymentListItem } from './usePayments';

interface Payload {
  id: string;
  data: {
    branchId: string;
    duration: number;
    downPayment: number;
    residual?: number;
    financialOptionId: string;
  };
}

const useCalculatePayment = (): [
  (payload: Payload) => void,
  RequestStateQuery,
  PaymentListItem | undefined,
] => {
  const { httpJson } = useHttp();

  const mutation = useMutation({
    mutationFn: (payload: Payload) => {
      return httpJson<ApiResponse<PaymentListItem>>(
        `${settings.get('EcomUri')}/payment/${payload.id}`,
        {
          ...buildPostRequest(payload.data),
        },
      );
    },
  });

  const { mutate, isPending, isSuccess, isError, data } = mutation;

  return [
    (payload: Payload) => mutate(payload),
    { isLoading: isPending, isSuccess, isError },
    data?.response,
  ];
};

export default useCalculatePayment;
